/**
 * @desc 售后入库单修改仓库
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inMaster.inMasterReturnChangeWarehouse.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inMaster/inMasterReturnChangeWarehouse`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
